export default async () => {

    const people = document.querySelectorAll('[data-staff-json]');
    const countdowns = document.querySelectorAll('[data-countdown]');

    if (!people.length && !countdowns.length) {
        return;
    }

    const [
        { default: React },
        { default: ReactDOM },
    ] = await Promise.all([
        import(/* webpackChunkName: "react-app" */ "react"),
        import(/* webpackChunkName: "react-app" */ "react-dom"),
    ]);

    for (const person of people) {
        const { default: StaffMember } = await import(/* webpackChunkName: "react-app" */ "./staff/StaffMember");
        const data = JSON.parse(person.getAttribute('data-staff-json'));
        ReactDOM.render(<StaffMember person={data} />, person);
    }

    for (const countdown of countdowns) {
        const { default: Countdown } = await import(/* webpackChunkName: "react-app" */ "./countdown/Countdown");
        const data = countdown.getAttribute('data-countdown');
        ReactDOM.render(<Countdown dateTime={data} />, countdown);
    }

}
